export const checkReturnInfoMaxRetries = 5
export const checkReturnInfoTimeInMs = 3000

export const completingMessages = [
  'Procesando datos...',
  'Validando...',
  'Enviando solicitud...',
  'Esperando respuesta...',
  'Recibiendo confirmación...',
]
